import { GptAPI } from "../apis/gpt";

export async function askGptByText(
  text: string,
  file_path?: string,
  limit?: number
) {
  if (!text) throw new Error("請輸入文字");


  const response = await fetch(
    GptAPI.askGptByText(text, file_path, limit).url,
    {
      method: GptAPI.askGptByText(text, file_path, limit).method,
    }
  );

  const json = await response.json();

  if (response.status !== 200) {
    console.error(json);
    alert("請重新嘗試");
    return;
  }

  return json;
}
